import { render, staticRenderFns } from "./branch-pc.vue?vue&type=template&id=6ff146e7"
import script from "./branch-pc.vue?vue&type=script&lang=ts"
export * from "./branch-pc.vue?vue&type=script&lang=ts"
import style0 from "./branch-pc.vue?vue&type=style&index=0&id=6ff146e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports